import {
  actionTypes,
  createSectionFailure,
  createSectionSuccess,
  sectionsRequestFailure,
  sectionsRequestSuccess,
  deleteSectionSuccess,
  deleteSectionFailure,
  getAttachmentsRequestSuccess,
  getAttachmentsRequestFailure,
  editSectionSuccess,
  editSectionFailure,
  getRoleInAttachmentRequestSuccess,
  getRoleInAttachmentRequestFailure,
  deleteAttachmentFromSectionSuccess,
  deleteAttachmentFromSectionFailure,
  saveAttachmentInSectionSuccess,
  saveAttachmentInSectionFailure,
  getAllRolesSuccess,
  getAllRolesFailure,
  updateRolesInAttachmentSuccess,
  updateRolesInAttachmentFailure,
} from "./actions";

import {
  fetchGetSections,
  fetchCreateSections,
  fetchDeleteSections,
  fetchUpdateSection,
  fetchGetAttachments,
  fetchDeleteAttachments,
  fetchSaveAttachments,
  fetchGetRoleInAttachment,
  fetchUploadRolesInAttachment,
  fetchGetAllRoles,
} from "./services";

import { ofType } from "redux-observable";
import { mergeMap, map, catchError } from "rxjs/operators";
import { of } from "rxjs";

const fetchSectionsRequestEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SECTIONS_REQUEST),
    mergeMap(() =>
      fetchGetSections().pipe(
        map((response: any) => sectionsRequestSuccess(response)),
        catchError((error: any) => of(sectionsRequestFailure(error)))
      )
    )
  );

const fetchCreateSectionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.CREATE_SECTION),
    mergeMap((action: any) =>
      fetchCreateSections(action.payload).pipe(
        map((response: any) => createSectionSuccess(response)),
        catchError((error: any) => of(createSectionFailure(error)))
      )
    )
  );

const fetchDeleteSectionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_SECTION),
    mergeMap((action: any) =>
      fetchDeleteSections(action.payload).pipe(
        map((response: any) => deleteSectionSuccess(response)),
        catchError((error: any) => of(deleteSectionFailure(error)))
      )
    )
  );

const fetchGetAttachmentsInSectionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SECTION_DETAIL_GET_ATTACHMENTS_REQUEST),
    mergeMap((action: any) =>
      fetchGetAttachments(action.payload).pipe(
        map((response: any) => getAttachmentsRequestSuccess(response)),
        catchError((error: any) => of(getAttachmentsRequestFailure(error)))
      )
    )
  );

const fetchEditSectionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.EDIT_SECTION),
    mergeMap((action: any) =>
      fetchUpdateSection(action.payload).pipe(
        map((response: any) => editSectionSuccess(response)),
        catchError((error: any) => of(editSectionFailure(error)))
      )
    )
  );

const fetchGetRolesInAttachmentEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ROLE_IN_ATTACHMENT_REQUEST),
    mergeMap((action: any) =>
      fetchGetRoleInAttachment(action.payload).pipe(
        map((response: any) => getRoleInAttachmentRequestSuccess(response)),
        catchError((error: any) => of(getRoleInAttachmentRequestFailure(error)))
      )
    )
  );

const fetchDeleteAttachmentFromSectionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.DELETE_ATTACHMENT_FROM_SECTION),
    mergeMap((action: any) =>
      fetchDeleteAttachments(action.payload).pipe(
        map((response: any) => deleteAttachmentFromSectionSuccess(response)),
        catchError((error: any) =>
          of(deleteAttachmentFromSectionFailure(error))
        )
      )
    )
  );

const fetchSaveAttachmentInSectionEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.SAVE_ATTACHMENT_IN_SECTION),
    mergeMap((action: any) =>
      fetchSaveAttachments(action.payload).pipe(
        map((response: any) => saveAttachmentInSectionSuccess(response)),
        catchError((error: any) => of(saveAttachmentInSectionFailure(error)))
      )
    )
  );

const fetchGetAllRolesEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.GET_ALL_ROLES),
    mergeMap(() =>
      fetchGetAllRoles().pipe(
        map((response: any) => getAllRolesSuccess(response)),
        catchError((error: any) => of(getAllRolesFailure(error)))
      )
    )
  );

const fetchUpdateRolesInAttachmentEpic = (action$: any) =>
  action$.pipe(
    ofType(actionTypes.UPDATE_ROLES_IN_ATTACHMENT),
    mergeMap((action: any) =>
      fetchUploadRolesInAttachment(action.id, action.payload).pipe(
        map((response: any) => updateRolesInAttachmentSuccess(response)),
        catchError((error: any) => of(updateRolesInAttachmentFailure(error)))
      )
    )
  );

export default [
  fetchSectionsRequestEpic,
  fetchCreateSectionEpic,
  fetchDeleteSectionEpic,
  fetchGetAttachmentsInSectionEpic,
  fetchEditSectionEpic,
  fetchGetRolesInAttachmentEpic,
  fetchDeleteAttachmentFromSectionEpic,
  fetchSaveAttachmentInSectionEpic,
  fetchGetAllRolesEpic,
  fetchUpdateRolesInAttachmentEpic,
];
